import React from "react";
import "../Styles/Product.css";

export default function ProductHead() {
  return (
    <div className="product-intro">
      <h1>Explore our products</h1>
      <p>Everyhing you need, any type of plant</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Components/ProductHead.js